(function () {
  if (window.__jiaCartPageInit) return;
  window.__jiaCartPageInit = true;

  document.querySelectorAll('[data-line-qty]').forEach((sel) => {
    sel.addEventListener('change', async () => {
      const row = sel.closest('[data-cart-row]');
      const key = row?.dataset.key;
      const qty = Number(sel.value);
      if (!key || Number.isNaN(qty)) return;
      sel.disabled = true;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        if (!res.ok) { alert('Could not update quantity'); sel.disabled = false; return; }
        window.location.reload();
      } catch (err) {
        alert('Network error updating quantity');
        sel.disabled = false;
      }
    });
  });
})();
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.bag-remove');
  if (!btn) return;
  const key = btn.dataset.removeKey;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(() => location.reload());
});
